var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "30D727C4-57F3-41B4-A3C7-ACA10AEB1774") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---8---Preview",
    transform: "translate(-259.000000, -235.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(100.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(30.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(20.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-1051894",
    transform: "translate(109.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "12.3347156 4.53634522 3.40439264 13.8184409 0.389731183 10.9180033 9.14519035 1.81844086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0854839,1.41344086 C10.0854839,1.41344086 10.9146237,0.323064516 11.3163978,0.133817204 C12.5267204,-0.436344086 15.18,1.89752688 14.4863441,3.18322581 C14.3069946,3.51567742 13.4391935,4.27129032 13.4391935,4.27129032",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.0247311828 11.9456989 3.01951613 14.9724194 0.0085483871 14.9558285"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.0d05cd15306f275faf4e586029b55edf.svg";
export { ForwardRef as ReactComponent };